/** @format */

import { defineStore } from "pinia";
import ajax from "@/ajax";

var date = new Date();
var m = date.getMonth() + 1;
var d = date.getDate();
var now =
    date.getFullYear() +
    "/" +
    (m < 10 ? "0" + m : m) +
    "/" +
    (d < 10 ? "0" + d : d);
/*if (now != localStorage.date && !ajax.get_url_argument_obj().loginnum) {
    localStorage.VCASE_user = ""
}*/

export const storeInit = defineStore({
    // id 是必填的，并且所有 Store 中唯一。因为Pinia会将它在devtools显示
    id: "store",
    state() {
        return {
            // user: JSON.parse(now == localStorage.date ? (localStorage.VCASE_user || "{}") : "{}"),
            user: JSON.parse(localStorage.VCASE_user || "{}"),
            re_load: true,
            tableData: [], // 存储表格数据（数组）
            dataTotal: 0, // 存储总数（数值）
            isLoginModalVisible: false, // 控制弹窗显示
            isAuthenticated: !!localStorage.VCASE_user, // 判断是否已登录
            targetPath: '/', // 默认跳转首页
        };
    },
    getters: {},
    actions: {
        setTableData(data) {
            this.tableData = data; 
        },
        setDataTotal(total) {
            this.dataTotal = total;
        },

        // 打开登录弹窗
        openLoginModal() {
            this.isLoginModalVisible = true;
            // console.log('弹窗已打开', this.isLoginModalVisible);
        },
        // 关闭登录弹窗
        closeLoginModal() {
            this.isLoginModalVisible = false;
            // console.log('弹窗已关闭', this.isLoginModalVisible);
        },
        // 登录成功后更新状态
        loginSuccess() {
            this.isAuthenticated = true;
            console.log('登录成功后更新状态', this.isAuthenticated)
            this.closeLoginModal();
        },
        // 登出时清除状态
        logout() {
            localStorage.Authorization_vcase = ""
            sessionStorage.Authorization_vcase = ""
            localStorage.VCASE_user = ""
            // localStorage.removeItem('token');
            this.isAuthenticated = false;
        },
        // 设置目标页地址
        setTargetPath(path) {
            this.targetPath = path; 
        },
        // 登录成功后重置目标页（避免下次登录错误跳转）
        resetTargetPath() {
            this.targetPath = '/'; 
        }
    },
});
